import React from 'react'
import USDefaultTemplate from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      lang="en"
      market="us"
      video={videos.boston_bruins.videoUrl}
      pageTitle="Watch Boston Bruins® hockey"
      title={
        <>
          Watch Boston Bruins<sup>®</sup> hockey
        </>
      }
      subtitle="Get live games, local team coverage & more"
      networkSet="hockey"
      customNetworks={['nesn']}
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-boston-bruins-v3.png?ch=width&auto=format,compress"
      logoHeight="100px"
      sportId={sportIds.Hockey}
      leagueId={leagueIds.NHL}
      teamId={teamIds['Boston Bruins']}
    />
  )
}
